import type { ScrollToColumnOptions } from '../types';

/**
 * Props for the DataTable.ScrollTo configuration component.
 */
export interface ScrollToProps extends ScrollToColumnOptions {
  /** Column ID to scroll to. null/undefined = no scroll action. */
  columnId?: string | null;
}

/**
 * Declarative config component that triggers scrollToColumn when columnId changes.
 *
 * @example
 * ```tsx
 * const [focusedColumn, setFocusedColumn] = useState<string | null>(null);
 *
 * <DataTable id="my-table" data={data}>
 *   <DataTable.ScrollTo columnId={focusedColumn} align="start" />
 *   <DataTable.Column id="name" accessor="name">
 *     <DataTable.Header>Name</DataTable.Header>
 *   </DataTable.Column>
 * </DataTable>
 * ```
 */
export const ScrollTo = (_props: ScrollToProps): null => {
  return null;
};
ScrollTo.displayName = 'DataTable.ScrollTo';
